// This file is for testing team for testing this feature

const modelInventoryFeatureLabel = 'ModelNew';
const modelAssociationFeatureLabel = 'Sub-Process New';
const modelRequestFeatureLabel = 'AssessmentNew';
const useCaseFeatureLabel = 'Use Case New';
const accessRequestFeatureLabel = 'Access Request New';

// This is our default file, do not edit anything. Please create new config file for different tenants
// Do not try to edit the key part of the object as it is having dependencies everywhere, make sure you understand the code before editing this file.
export const LABEL_CONFIG_DYNAMIC_LABELING_TEST = {
  MENUS: {
    home: {
      label: 'HomeNew',
      path: 'homeNew',
    },
    inventory: {
      label: 'InventoryNew',
      path: 'inventoryNew',
    },
    modelInventory: {
      label: 'Models New',
      featureLabel: modelInventoryFeatureLabel, // If you are changing this change it in the template type as well
      path: 'model-new', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createModel: {
          label: 'Add Model New',
          path: 'model-new/add-model-new',
        },
        editModel: {
          label: 'Edit Model New',
          path: 'model-new/:uniqueId',
        },
        archivedModels: {
          label: 'Archived Models New',
          path: 'model-new/archived-new',
        },
      },
    },
    modelRequest: {
      label: 'AssessmentsNew',
      featureLabel: modelRequestFeatureLabel, // If you are changing this change it in the template type as well
      path: 'assessments-new', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editModelRequest: {
          label: 'Edit Assessment New',
          path: 'assessments-new/:uniqueId',
        },
        archivedModelRequest: {
          label: 'Archived Assessments',
          path: 'assessments-new/archived',
        },
      },
    },
    useCase: {
      label: 'Use Cases New',
      featureLabel: useCaseFeatureLabel, // If you are changing this change it in the template type as well
      path: 'useCases-new', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editUseCase: {
          label: 'Edit Use Case New',
          path: 'useCases-new/:uniqueId',
        },
        archivedUseCase: {
          label: 'Archived Use Cases',
          path: 'useCases-new/archived',
        },
      },
    },
    ModelAssociation: {
      label: 'Model Sub-Process New',
      featureLabel: modelAssociationFeatureLabel, // If you are changing this change it in the template type as well
      path: 'model-sub-process-new', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        allArtifacts: {
          label: 'All Sub-Process New',
          path: 'model-sub-process-new',
        },
        editModelAssociation: {
          label: 'Edit Sub-Process New',
          path: 'model-sub-process-new/:uniqueId',
        },
        archivedArtifacts: {
          label: 'Archived Sub-Process New',
          path: 'model-sub-process-new/archived-new',
        },
      },
    },
    DocumentInventory: {
      label: 'DocumentsNew',
      path: 'documents-new',
    },
    rules: {
      label: 'RulesNew',
      path: 'rules-new',
    },
    report: {
      label: 'ReportsNew',
      path: 'reports-new',
    },
    bulkActions: {
      label: 'Bulk Actions New',
      path: 'bulk-actions-new',
    },
    bulkUpload: {
      label: 'Bulk Upload new',
      path: 'bulk-upload-new',
      subPaths: {
        bulkUploadActivityDetail: {
          label: 'View Activity',
          path: 'bulk-upload-new/activity/:activityId',
        },
        bulkUploadPage: {
          label: 'Upload',
          path: 'bulk-upload-new/upload',
        },
      },
    },
    bulkTransition: {
      label: 'Bulk Transition New',
      path: 'bulk-transition-new',
    },
    bulkUpdate: {
      label: 'Bulk Update New',
      path: 'bulk-update-new',
      subPaths: {
        bulkUpdateActivityDetail: {
          label: 'View Activity',
          path: 'bulk-update-new/activity/:activityId',
        },
        bulkUpdatePage: {
          label: 'Update',
          path: 'bulk-update-new/update',
        },
      },
    },
    bulkDocumentUpload: {
      label: 'Bulk Document Upload',
      path: 'bulk-document',
    },
    Configuration: {
      label: 'Configuration New',
      path: 'configuration-new',
    },
    globalAttributes: {
      label: 'Global Attributes',
      featureLabel: 'Global Attributes',
      path: 'global-attributes',
    },
    Attributes: {
      label: 'Attributes',
      featureLabel: 'Attributes',
      path: 'attributes',
    },
    constantAttributes: {
      label: 'Constant Attributes',
      featureLabel: 'Constant Attributes',
      path: 'constant-attributes',
    },
    teamRoles: {
      label: 'Team Roles',
      featureLabel: 'Team Roles',
      path: 'team-roles',
    },
    workflow: {
      label: 'Workflows New',
      featureLabel: 'Workflow New',
      path: 'workflows-new', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editWorkflow: {
          label: 'Edit Workflow New',
          path: 'workflows-new/edit-workflow-new/:workflowType/:workflowId',
        },
        generateWorkflow: {
          label: 'Generate Workflow',
          path: 'workflows/generate-workflow',
        },
      },
    },
    templateList: {
      label: 'Templates New',
      path: 'templates-new', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createTemplate: {
          label: 'Create Template New',
          path: 'templates-new/create-template-new',
        },
        editTemplate: {
          label: 'Edit Template',
          path: 'templates-new/edit-template-new/:tId/:vId',
        },
      },
    },
    documentTemplate: {
      label: 'Document Template New',
      path: 'document-template-new',
    },
    dynamicChart: {
      label: 'Dynamic Chart New',
      path: 'dynamic-chart-new',
    },
    dynamicToolbar: {
      label: 'Dynamic Toolbar',
      featureLabel: 'Dynamic Toolbar',
      path: 'dynamic-toolbar',
      subPaths: {
        createDynamicToolbar: {
          label: 'Create Dynamic Toolbar',
          path: 'dynamic-toolbar/new',
        },
        editDynamicToolbar: {
          label: 'Edit Dynamic Toolbar',
          path: 'dynamic-toolbar/:uniqueId',
        },
      },
    },
    automation: {
      label: 'Automation New',
      path: 'automation-new', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        createAutomation: {
          label: 'Create Automation New',
          path: 'automation-new/create-automation-new',
        },
        updateAutomation: {
          label: 'Update Automation New',
          path: 'automation-new/update-automation-new/:id',
        },
        automationLineage: {
          label: 'Automation Lineage New',
          path: 'automation-new/lineage/:id',
        },
      },
    },
    themeAndAppearance: {
      label: 'Theme and Appearance New',
      path: 'theme-and-appearance-new',
    },
    emailTemplate: {
      label: 'Email Template New',
      path: 'email-template-new',
    },
    helpAndSupport: {
      label: 'Help and Support New',
      path: 'help-new',
    },
    administrativeOptions: {
      label: 'Administrative Options New',
      path: 'administrative-options-new',
    },
    userManagement: {
      label: 'User Management New',
      path: 'user-management-new',
    },
    appManagement: {
      label: 'App Management New',
      path: 'app-management-new',
    },
    documentInventory: {
      label: 'Documents New',
      path: 'documents-new',
    },
    accessRequest: {
      label: 'Access Request New',
      featureLabel: accessRequestFeatureLabel, // If you are changing this change it in the template type as well
      path: 'accessRequest-new', // If you are changing this parents path, make sure to change it in subPaths as well
      subPaths: {
        editAccessRequest: {
          label: 'Edit Access Request New',
          path: 'accessRequest-new/:uniqueId',
        },
      },
    },
    homepageSetup: {
      label: 'Homepage Setup New',
      path: 'homepage-setup-new',
    },
    logs: {
      label: 'Logs',
      path: 'logs',
      subPaths: {
        configurationLogs: {
          label: 'System Logs',
          path: 'logs/system-logs',
        },
        inventoryLogs: {
          label: 'Inventory Logs',
          path: 'logs/inventory-logs',
        },
      },
    },
  },
  LABELS: {
    modelInventory: {
      otherDetails: {
        label: 'Other Details',
      },
      modelLifecycleEventDropdown: {
        label: 'Issue Type New',
      },
      table: {
        column: {
          ModelHealth: {
            label: 'Model Health New',
          },
        },
      },
    },
    modelAssociation: {
      otherDetails: {
        label: 'Other Details',
      },
      artifactLifecycleEventDropdown: {
        label: 'Issue Type New',
      },
      table: {
        column: {
          ArtifactHealth: {
            label: 'Sub-Process Health New',
          },
        },
      },
    },
    useCase: {
      usecaseLifecycleEventDropdown: {
        label: 'Issue Type New',
      },
    },
    modelRequest: {
      modelRequestLifecycleEventDropdown: {
        label: 'Issue Type New',
      },
    },
    userManagement: {
      groups: {
        label: 'Groups',
        uppercaseLabel: 'GROUPS',
      },
      group: {
        label: 'Group',
        uppercaseLabel: 'GROUP',
      },
      table: {
        column: {
          role: {
            label: 'ROLE',
          },
        },
      },
    },
  },
  // If you are changing this part, then make sure you are changing the paths and menus labels to these.
  TEMPLATE_TYPES: {
    ModelInventory: {
      label: 'ModelInventoryNew',
      featureLabel: modelInventoryFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    ModelAssociation: {
      label: 'ModelAssociationNew',
      featureLabel: modelAssociationFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    ModelRequest: {
      label: 'Assessment New',
      featureLabel: modelRequestFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    AccessRequest: {
      label: 'Access Request New',
      featureLabel: accessRequestFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
    UseCase: {
      label: 'Use Case New',
      featureLabel: useCaseFeatureLabel, // This feature label is used to show in the places where we want to show different name instead of we show in dropdown, for example our ModelInventory label is ModelInventory but we show it as Model everywhere.
      // If you are changing this change it in the Menus as well
    },
  },
};
